import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Gift, Menu, X } from "lucide-react";

const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <nav className="sticky top-0 z-50 glass border-b border-border/50">
      <div className="container mx-auto flex items-center justify-between h-16 px-4">
        <Link to="/" className="flex items-center gap-2 group">
          <Gift className="h-7 w-7 text-accent transition-transform duration-300 group-hover:rotate-12" />
          <span className="font-heading text-xl font-bold text-primary tracking-tight">Speshly</span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          <a href="#how-it-works" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors relative after:absolute after:bottom-0 after:left-0 after:w-0 after:h-0.5 after:bg-accent after:transition-all after:duration-300 hover:after:w-full">How it works</a>
          <a href="#pricing" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors relative after:absolute after:bottom-0 after:left-0 after:w-0 after:h-0.5 after:bg-accent after:transition-all after:duration-300 hover:after:w-full">Pricing</a>
          <Link to="/login">
            <Button variant="ghost" size="sm">Sign in</Button>
          </Link>
          <Link to="/signup">
            <Button variant="nav" size="sm">Get Started</Button>
          </Link>
        </div>

        <button
          className="md:hidden p-2 -mr-2"
          onClick={() => setOpen(!open)}
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-border/50 glass px-4 py-4 space-y-3">
          <a href="#how-it-works" className="block text-sm font-medium text-muted-foreground">How it works</a>
          <a href="#pricing" className="block text-sm font-medium text-muted-foreground">Pricing</a>
          <Link to="/login" className="block"><Button variant="ghost" className="w-full">Sign in</Button></Link>
          <Link to="/signup" className="block"><Button variant="nav" className="w-full">Get Started</Button></Link>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
